/**
 * Finds the Collection a "Buy a Publish Credit" click should check out —
 * the active Collection bound to the draft's template — by scanning the
 * public catalog in its own display order. Bounded to
 * MAX_CATALOG_PAGES_SCANNED pages (50/page, the backend's max) so a large
 * catalog never fans out into unbounded requests; past that, the caller
 * falls back to the `/catalog` page.
 *
 * ponytail: client-side scan; add `?templateId=` to GET /v1/collections if
 * the catalog ever outgrows a few hundred Collections.
 */
import { fetchCollections } from '@/src/modules/catalog/api';
import type { Collection } from '@/src/modules/catalog/types';
import { pickCollectionForTemplate } from './buyCreditIntent';

export const MAX_CATALOG_PAGES_SCANNED = 4;
const PAGE_SIZE = 50;

export async function resolveCreditCollection(templateId: string | undefined): Promise<Collection | null> {
  if (!templateId) return null;
  for (let page = 1; page <= MAX_CATALOG_PAGES_SCANNED; page += 1) {
    const result = await fetchCollections({ page, pageSize: PAGE_SIZE, sort: 'display_order' });
    const match = pickCollectionForTemplate(result.items, templateId);
    if (match) return match;
    if (page >= result.meta.totalPages) break;
  }
  return null;
}
